export default __webpack_public_path__ + "static/times-money-mentor-best-current-account-2023-5f0844e38b9e6acc0918c1dc806c314e.svg";